import { Button, Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';
import { useSnapshot } from 'valtio';

import { BillingPriceSummaryDetail } from './BillingPriceSummaryDetail';
import { BillingPriceSummaryDiscount } from './BillingPriceSummaryDiscount';
import { PaymentState } from './BillingReceipt.state';

interface BillingProcessingProps {
  readonly className?: string;
}

function BillingProcessing({ className }: BillingProcessingProps) {
  const {
    amount: { coupon, total },
  } = useSnapshot(PaymentState);
  const { useBillingData } = PaymentState;

  useBillingData();

  return (
    <div className={twMerge('flex-1', className)}>
      <Text as="h4" variant="subtitle-2" weight="medium" color="black" className="mb-4 p-4">
        Payment
      </Text>
      <div className="flex flex-col gap-2.5 rounded-xl bg-blue-50 p-6">
        <div className="rounded-xl bg-white px-6 py-2">
          <BillingPriceSummaryDetail price={total.finalPrice - coupon.amount} label="Sub Total">
            <div className="flex flex-row justify-between">
              <Text variant="body-2" className="flex-1 text-neutral-600 md:whitespace-pre">
                {total.newExpiry ? `expiration date will be extended to\n${total.newExpiry}` : ''}
              </Text>
              {total.originalPrice > total.finalPrice ? <BillingPriceSummaryDiscount price={total.originalPrice} /> : null}
            </div>
          </BillingPriceSummaryDetail>
        </div>
        <Button icon="card-number" variant="info" disabled>
          <Text as="span" className="w-full text-center">
            Please wait, payment is under process
          </Text>
        </Button>
      </div>
    </div>
  );
}

export { BillingProcessing };
